import { Pipe, PipeTransform } from '@angular/core';
import { ActiveLookup, Excursion, ExcursionKeys, LookupKeys } from 'ag-common-lib/public-api';
import { format } from 'date-fns';

@Pipe({ name: 'conferenceActivitiesDays' })
export class ConferenceActivitiesDaysPipe implements PipeTransform {
  transform(activities: Excursion[] = [], chairmanActivities: Excursion[] = []): Partial<ActiveLookup>[] {
    const allActivities: Excursion[] = [...(activities ?? []), ...(chairmanActivities ?? [])].filter(Boolean);
    const activitiesDates = Array.from(
      new Set(allActivities.map(activity => activity?.[ExcursionKeys.date]).filter(Boolean)),
    ).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

    const lookup = activitiesDates.map(date => {
      const description = format(new Date(date), 'EEEE, LLLL d, yyyy');

      return Object.assign(
        {},
        {
          [LookupKeys.value]: date,
          [LookupKeys.description]: description,
        },
      );
    });

    return lookup;
  }
}
